import React from 'react'

import { useIsRecipeInStock } from 'hooks/menu-recipes/useIsRecipeInStock'
import { useRecipeIdByCoreId } from 'hooks/menu-recipes/useRecipeIdByCoreId'
import { RecipeCoreId } from 'reducers/menu-recipes/recipes'

import { useRecipeId } from '../../../context/recipeContext'

import css from './SoldOutOverlay.css'

export const SoldOutOverlay: React.FC = () => {
  const recipeCoreId = useRecipeId() as RecipeCoreId
  const recipeUUID = useRecipeIdByCoreId(recipeCoreId)
  const isOutOfStock = !useIsRecipeInStock(recipeUUID)

  if (!isOutOfStock || !recipeCoreId) {
    return null
  }

  return (
    <div className={css.overlay}>
      <span className={css.overlayText}>This recipe is sold out for your delivery date</span>
    </div>
  )
}
